// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-center {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fj-center {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.f-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.fb-center {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.pointer {
  cursor: pointer;
}

.un {
  -webkit-user-select: none;
          user-select: none;
}

.fit-image {
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
  overflow: hidden;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.shadow {
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.0588235294);
  background-color: var(--ffff);
  border-radius: 4px;
}

.v-hide {
  visibility: hidden;
}

.br-4 {
  border-radius: 4px;
}

.br-8 {
  border-radius: 8px !important;
}

.br-10 {
  border-radius: 10px;
}

.br-12 {
  border-radius: 12px;
}

.br-14 {
  border-radius: 14px;
}

.br-16 {
  border-radius: 16px;
}

.br-20 {
  border-radius: 20px;
}

.br-22 {
  border-radius: 22px !important;
}

.brb-14 {
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.brt-14 {
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
}

.text-elipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hover-effect {
  cursor: pointer;
  color: var(--7e91);
}
.hover-effect:hover {
  text-decoration: underline;
  color: var(--56ff) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAIF;;AADA;EACE,eAAA;AAIF;;AAFA;EACE,yBAAA;UAAA,iBAAA;AAKF;;AAHA;EACE,4BAAA;EACA,kCAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAMF;;AAHA;EACE,wDAAA;EACA,6BAAA;EACA,kBAAA;AAMF;;AAJA;EACE,kBAAA;AAOF;;AALA;EACE,kBAAA;AAQF;;AANA;EACE,6BAAA;AASF;;AAPA;EACE,mBAAA;AAUF;;AARA;EACE,mBAAA;AAWF;;AATA;EACE,mBAAA;AAYF;;AAVA;EACE,mBAAA;AAaF;;AAXA;EACE,mBAAA;AAcF;;AAZA;EACE,8BAAA;AAeF;;AAbA;EACE,+BAAA;EACA,gCAAA;AAgBF;;AAdA;EACE,4BAAA;EACA,6BAAA;AAiBF;;AAdA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAiBF;;AAfA;EACE,eAAA;EACA,kBAAA;AAkBF;AAjBE;EACE,0BAAA;EACA,6BAAA;AAmBJ","sourcesContent":[".fa-center {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n.fj-center {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n.f-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n.fb-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n.un {\r\n  user-select: none;\r\n}\r\n.fit-image {\r\n  background-repeat: no-repeat;\r\n  background-position: bottom center;\r\n  background-size: cover;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.shadow {\r\n  box-shadow: 0px 4px 16px 0px #0000000f;\r\n  background-color: var(--ffff);\r\n  border-radius: 4px;\r\n}\r\n.v-hide {\r\n  visibility: hidden;\r\n}\r\n.br-4 {\r\n  border-radius: 4px;\r\n}\r\n.br-8 {\r\n  border-radius: 8px !important;\r\n}\r\n.br-10 {\r\n  border-radius: 10px;\r\n}\r\n.br-12 {\r\n  border-radius: 12px;\r\n}\r\n.br-14 {\r\n  border-radius: 14px;\r\n}\r\n.br-16 {\r\n  border-radius: 16px;\r\n}\r\n.br-20 {\r\n  border-radius: 20px;\r\n}\r\n.br-22 {\r\n  border-radius: 22px !important;\r\n}\r\n.brb-14 {\r\n  border-bottom-left-radius: 14px;\r\n  border-bottom-right-radius: 14px;\r\n}\r\n.brt-14 {\r\n  border-top-left-radius: 14px;\r\n  border-top-right-radius: 14px;\r\n}\r\n\r\n.text-elipses {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.hover-effect {\r\n  cursor: pointer;\r\n  color: var(--7e91);\r\n  &:hover {\r\n    text-decoration: underline;\r\n    color: var(--56ff) !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
